import React from 'react'
import { Col, Row } from 'reactstrap'
import { withRouter } from 'react-router'
import ola from 'shared/images/ola_seal.png'
import PropTypes from 'prop-types'
import DMPAMoreInfo from 'application/components/NonApprovedLead/AlternateLanding/DMPAMoreInfo'
import { APPLICATION_PATHS } from 'constants/paths'

const FooterLinks = ({ footerLinks, CCBFooter = false, location }) => {
  if (!footerLinks) return null

  const footerColSize = CCBFooter ? 11 : 8
  const imgColSize = CCBFooter ? 1 : 4
  return (
    <React.Fragment>
      {location.pathname ===
        APPLICATION_PATHS.NOT_APPROVED_LEAD_WELCOME_DMPA && (
        <DMPAMoreInfo extended={true} />
      )}

      <div id="links-copyright">
        <Row>
          <Col lg={footerColSize} className="mb-3">
            {footerLinks.map((document, index) => (
              <React.Fragment key={document.idTag}>
                <a
                  id={document.idTag}
                  data-test={`links.footer.${document.idTag}`}
                  href={document.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {document.title}
                </a>

                {index < footerLinks.length - 1 && (
                  <span className="spacer">
                    {'  '}|{'  '}
                  </span>
                )}
              </React.Fragment>
            ))}
          </Col>
          <Col lg={imgColSize} className="text-right mb-3">
            <img
              data-test="images.ola"
              id="ola_seal"
              src={ola}
              alt="OLA Seal"
            />
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}

FooterLinks.propTypes = {
  footerLinks: PropTypes.arrayOf(
    PropTypes.shape({
      idTag: PropTypes.string,
      url: PropTypes.string,
      title: PropTypes.string,
    })
  ),
  CCBFooter: PropTypes.bool,
  location: PropTypes.object,
}

export default withRouter(FooterLinks)
